export enum ReceiveOrderStatusEnum {
  /** 注文受付前 */ BEFORE_ORDER_ACCEPT = '0',
  /** 未確定 */ NOT_CONFIRM = '1',
  /** 確定済 */ CONFIRM = '2',
  /** キャンセル */ CANCEL = '9',
}

export const ReceiveOrderStatus = [
  { label: '注文受付中', value: ReceiveOrderStatusEnum.BEFORE_ORDER_ACCEPT },
  { label: '未確定', value: ReceiveOrderStatusEnum.NOT_CONFIRM },
  { label: '確定済', value: ReceiveOrderStatusEnum.CONFIRM },
  { label: 'キャンセル', value: ReceiveOrderStatusEnum.CANCEL },
];

export const ReceiveOrderStatusForApprovalListCheckbox = [
  { label: '注文受付中', value: ReceiveOrderStatusEnum.BEFORE_ORDER_ACCEPT },
  { label: 'キャンセル', value: ReceiveOrderStatusEnum.CANCEL },
];

// 確定済とキャンセル
export const ReceiveOrderStatusForConfirmedAndCancelled = [
  { label: '未確定', value: ReceiveOrderStatusEnum.NOT_CONFIRM },
  { label: '確定済', value: ReceiveOrderStatusEnum.CONFIRM },
];
